<!-- svelte-ignore non-top-level-reactive-declaration -->

<script lang="ts">
    import { afterUpdate, onMount } from "svelte";
    import { MUNIO } from "$lib/munio";
    import { page } from "$app/stores";
    import { logoutUser } from "./navbar";
    import { goto } from "$app/navigation";
    import { signOut } from "firebase/auth";
    import { auth } from "$lib/firebase.client";
    import { getAuthToken } from "$lib/stores/auth";
    import { clearCookie } from "../../utils/cookie";
    import showToast from "$lib/components/toasts/toaster";
    import avatar_null from "$lib/assets/images/avatar-null.svg";
    import { clientCode } from "$lib/stores/store";
    import {
        authTokenStore,
        clientKeyStore,
        clientProfileStore,
        isInitialized,
        loadingStore,
        profileStore,
    } from "../../../store/initStore";
    import { get } from "svelte/store";

    export let data: any = [];
    export let dataPermission: any = [];
    export let appreanceConfig: any = [];
    export let customPath: any = [];

    $: clients = data;
    $: permissions = dataPermission;
    $: appreanceConfig = dataPermission?.data;
    $: authToken = $authTokenStore;
    $: clientKey = $clientKeyStore;
    $: loading = $loadingStore;

    const primaryColor = dataPermission?.data?.colors?.primary;
    // const secondaryColor = dataPermission?.data?.colors?.secondary

    let profile: any;
    let clientProfile: any;

    let y = 0;
    // let authToken: any;
    // let profile: any = {data: {}}
    // let clientKey:any = ''
    // let clientProfile:any = {}
    // let loading:boolean = true

    let popupProfile: boolean = false;
    let isPageLoaded: boolean = false;
    let viewMenu: boolean = false;

    async function handleLogout() {
        window.location.reload();
        window.location.href = "/login";
        await logoutUser();
        clearCookie("AUTH_KEY");

        localStorage.removeItem("avatar_fb");
        localStorage.removeItem("avatar_apple");
        localStorage.removeItem("avatar_google");

        sessionStorage.removeItem("xs");
        sessionStorage.removeItem("ck");
        sessionStorage.removeItem("isMembers");
        sessionStorage.removeItem("canaccess");

        if (auth) {
            await signOut(auth);
        }
        showToast("Berhasil keluar. Tunggu sebentar!", "success");
        if (window.location.pathname === "/members") {
            window.location.href = "login";
        }
    }

    export async function initialize() {
        authToken = await getAuthToken();
        authTokenStore.set(authToken);
        if (authToken) {
            MUNIO.initMunio($page.url.origin);

            sessionStorage.removeItem("xs");
            sessionStorage.removeItem("ck");
            sessionStorage.removeItem("isMembers");
            sessionStorage.removeItem("canaccess");

            profile = await MUNIO.getProfile();
            const isProfileIdInvalid = !profile?.data?.member?.data?.id;
            const isMemberActive = profile?.data?.member?.data?.is_active === 1;

            if (!isProfileIdInvalid && isMemberActive) {
                sessionStorage.setItem("xs", "false");
                sessionStorage.setItem("ck", "true");
                sessionStorage.setItem("isMembers", "members");
                sessionStorage.setItem("canaccess", "true");
            }

            profileStore.set(profile);
        }

        try {
            loading = true;
            loadingStore.set(true);
            const clientKeyPromise = $page.url.origin;
            MUNIO.initMunio($page.url.origin);
            const clientProfilePromise = MUNIO.getClient();

            clientKey = await clientKeyPromise;
            clientProfile = await clientProfilePromise;
            clientKeyStore.set(clientKey);
            clientProfileStore.set(clientProfile);
            clientCode.set(clientProfile?.code);
            loading = false;
            loadingStore.set(false);
        } catch (error) {
            console.error("Error:", error);
            loading = false;
            loadingStore.set(false);
        }
    }

    onMount(async () => {
        if (!get(isInitialized)) {
            await initialize();
            if (authToken) {
                isInitialized.set(true);
            }
        }
        $: profile = $profileStore;
        $: clientProfile = $clientProfileStore;
    });

    let isMenuOpen = false;

    function onClickButton() {
        isMenuOpen = !isMenuOpen;
    }

    function clickOutside(element: any, callbackFunction: any) {
        function onClick(event: any) {
            if (!element.contains(event.target)) {
                callbackFunction();
            }
        }

        document.body.addEventListener("click", onClick);

        return {
            update(newCallbackFunction: any) {
                callbackFunction = newCallbackFunction;
            },
            destroy() {
                document.body.removeEventListener("click", onClick);
            },
        };
    }

    const handleViewMenuTrue = () => {
        viewMenu = true;
    };

    const handleViewMenuFalse = () => {
        viewMenu = false;
    };

    const getAvatar = () => {
        const avatarFromProfile = profile?.data?.avatar?.small;
        const avatarFromFB = localStorage.getItem("avatar_fb");
        const avatarFromGoogle = localStorage.getItem("avatar_google");
        const avatarFromApple = localStorage.getItem("avatar_apple");

        if (
            !avatarFromProfile &&
            !avatarFromFB &&
            !avatarFromGoogle &&
            avatarFromApple
        ) {
            return avatar_null;
        }

        return (
            avatarFromProfile ||
            avatarFromFB ||
            avatarFromGoogle ||
            avatarFromApple ||
            avatar_null
        );
    };
</script>

<svelte:window bind:scrollY={y} />

<header
    class={`header--has-logo header--has-topbar header--has-search header--has-social-links z-20 !sticky top-0 ${clients?.code === "catchmeup" ? "bg-[#EFE7F0]" : "bg-white"} border border-solid border-[#E9E9EA]`}
>
    <div class="header__inner">
        <!-- HEADER NAVBAR : begin -->
        <div class="lg:py-[20px] py-[0px]">
            <div class="header__navbar-inner md:mx-6">
                <!-- HEADER NAVBAR CONTAINER : begin -->
                <div class="header__navbar-container">
                    <!-- HEADER BRANDING : begin -->
                    <div class="header-branding">
                        <div class="header-branding__inner">
                            <!-- HEADER LOGO : begin -->
                            <div class="header-logo">
                                {#if clients}
                                    <a
                                        href="/"
                                        class="header-logo__link"
                                        data-sveltekit-reload
                                    >
                                        <img
                                            loading="lazy"
                                            class={`
                          ${
                              clients?.subdomain === "katetigama"
                                  ? "w-[8rem]"
                                  : clients?.code === "catchmeup"
                                    ? "w-[3rem]"
                                    : "w-[5rem]"
                          } 
                          my-auto`}
                                            src={`${clients?.icon === null ? "/munio-logo.png" : clients?.icon}`}
                                            alt={clients?.full_name}
                                        />
                                    </a>
                                {/if}
                            </div>
                            <!-- HEADER LOGO : end -->
                        </div>
                    </div>
                    <!-- HEADER BRANDING : end -->
                    <!-- HEADER MOBILE MENU TOGGLE : begin -->

                    <button
                        on:click={onClickButton}
                        class="header-mobile-menu-toggle"
                    >
                        <span class="header-mobile-menu-toggle__icon" />
                    </button>

                    <button
                        on:click={onClickButton}
                        type="button"
                        class="header-mobile-menu-toggle"
                        title="Expand menu"
                        data-label-collapse-popup="Collapse menu"
                        data-label-expand-popup="Expand menu"
                        aria-controls="header__navbar-menu"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                        <span class="header-mobile-menu-toggle__icon" />
                    </button>
                    <!-- HEADER MOBILE MENU TOGGLE : end -->
                </div>
                <!-- HEADER NAVBAR CONTAINER : end -->

                <!-- HEADER NAVBAR MENU : begin -->
                <div
                    id="header__navbar-menu"
                    class={`${isMenuOpen ? "open" : "closed"} items-center`}
                >
                    <!-- PRIMARY HEADER MENU : begin -->
                    <nav
                        id="header-menu-primary"
                        class="header-menu-primary relative"
                        aria-label="Primary Header Menu"
                        data-label-expand-popup="Expand submenu"
                        data-label-collapse-popup="Collapse submenu"
                    >
                        <ul class="header-menu-primary__list" role="menu">
                            <li
                                class="header-menu-primary__item header-menu-primary__item--level-1"
                                role="presentation"
                            >
                                <a
                                    data-sveltekit-reload
                                    href="/"
                                    data-sveltekit-preload-code="eager"
                                    style={`color: ${primaryColor} !important`}
                                    class="header-menu-primary__item-link header-menu-primary__item-link--level-1 hover:!text-[#14161C] hover:!text-opacity-80 hover:no-underline"
                                    role="menuitem"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    class:header-menu-primary__item-link--current={$page
                                        .url.pathname === `/`}
                                >
                                    <span
                                        class="header-menu-primary__item-link-label"
                                        >Beranda</span
                                    >
                                </a>
                                <!-- MENU LEVEL 2 WRAPPER : end -->
                            </li>
                            {#if Array.isArray(permissions?.data?.website_main?.items)}
                                {#each permissions?.data?.website_main?.items as permission}
                                    {#if permission.module !== "broadcast"}
                                        <li
                                            class="header-menu-primary__item header-menu-primary__item--level-1 hover:no-underline"
                                            role="presentation"
                                        >
                                            {#if permission?.module === "external"}
                                                <a
                                                    data-sveltekit-reload
                                                    data-sveltekit-preload-code="eager"
                                                    href={`${permission.ref}`}
                                                    target="_blank"
                                                    style={`color: ${primaryColor} !important`}
                                                    class={`header-menu-primary__item-link header-menu-primary__item-link--level-1 hover:!text-slate-800 hover:!text-opacity-80 hover:no-underline ${permission?.ref === "" && "pointer-events-none opacity-70"}`}
                                                    role="menuitem"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    class:header-menu-primary__item-link--current={$page.url.pathname.includes(
                                                        `${permission.module}`,
                                                    )}
                                                >
                                                    <span
                                                        class="header-menu-primary__item-link-label"
                                                        >{permission.label}</span
                                                    >
                                                </a>
                                            {:else if permission?.module === "path"}
                                                <a
                                                    data-sveltekit-reload
                                                    data-sveltekit-preload-code="eager"
                                                    href={`${permission?.ref}`}
                                                    role="menuitem"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    style={`color: ${primaryColor} !important;`}
                                                    class="header-menu-primary__item-link header-menu-primary__item-link--level-1 hover:!text-slate-800 hover:!text-opacity-80 hover:no-underline"
                                                    class:header-menu-primary__item-link--current={(() => {
                                                        const currentPath =
                                                            $page.url.pathname.endsWith(
                                                                "/",
                                                            )
                                                                ? $page.url.pathname.slice(
                                                                      0,
                                                                      -1,
                                                                  )
                                                                : $page.url
                                                                      .pathname;
                                                        const permissionPath =
                                                            permission.ref.endsWith(
                                                                "/",
                                                            )
                                                                ? permission.ref.slice(
                                                                      0,
                                                                      -1,
                                                                  )
                                                                : permission.ref;
                                                        return (
                                                            customPath?.includes(
                                                                currentPath,
                                                            ) &&
                                                            currentPath ===
                                                                permissionPath
                                                        );
                                                    })()}
                                                >
                                                    <span
                                                        class="header-menu-primary__item-link-label"
                                                        >{permission.label}</span
                                                    >
                                                </a>
                                            {:else if permission?.is_dropdown === 1}
                                                <button
                                                    class="xs:-mb-5 md:-mb-4 lg:-mb-10 md:-mr-3 mr-3 !w-full header-menu-primary__item-link--level-1 hover:!text-slate-800 hover:!text-opacity-80 hover:no-underline"
                                                    role="menuitem"
                                                    use:clickOutside={() => {
                                                        handleViewMenuFalse();
                                                    }}
                                                    on:click={(event) => {
                                                        event.stopPropagation();
                                                        handleViewMenuTrue();
                                                    }}
                                                >
                                                    <div
                                                        class="flex flex-row items-center !w-full"
                                                    >
                                                        <p
                                                            style={`color: ${primaryColor} !important;`}
                                                            class="header-menu-primary__item-link !w-full text-start"
                                                            class:header-menu-primary__item-link--current={!customPath?.includes(
                                                                $page.url
                                                                    .pathname,
                                                            ) &&
                                                                $page.url.pathname.includes(
                                                                    `${permission.module === "about uses" ? `about-us` : permission.module}`,
                                                                )}
                                                        >
                                                            <span
                                                                class="header-menu-primary__item-link-label"
                                                                >{permission.label}</span
                                                            >
                                                        </p>
                                                        <p
                                                            class="flex flex-row items-center rounded-lg"
                                                        >
                                                            <svg
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g
                                                                    id="ri:arrow-drop-down-fill"
                                                                >
                                                                    <path
                                                                        id="Vector"
                                                                        d="M12 14L8 10H16L12 14Z"
                                                                        fill="#080808"
                                                                        fill-opacity="0.4"
                                                                    />
                                                                </g>
                                                            </svg>
                                                        </p>
                                                    </div>
                                                </button>
                                                {#if viewMenu}
                                                    <div
                                                        class="h-auto z-20 3xs:top-[4rem] xs:top-[4rem] xs:w-full sm:top-[4rem] md:top-[4rem] lg:top-[6rem] xl:top-[3rem] !bg-white p-3 right-30 absolute flex flex-col gap-1 overflow-auto border rounded-lg"
                                                        style="scrollbar-width: thin; scrollbar-color: rgba(155, 155, 155, 0.5) transparent;"
                                                    >
                                                        {#each permission?.ref as itemMenu}
                                                            <a
                                                                data-sveltekit-reload
                                                                data-sveltekit-preload-code="eager"
                                                                href={`${itemMenu?.ref}`}
                                                                role="menuitem"
                                                                aria-haspopup="true"
                                                                aria-expanded="false"
                                                                style={`color: ${primaryColor} !important;`}
                                                                class="hover:bg-slate-100 px-3 py-2 rounded-lg cursor-pointer header-menu-primary__item-link header-menu-primary__item-link--level-1 hover:!text-slate-800 hover:!text-opacity-80 hover:no-underline"
                                                                class:header-menu-primary__item-link--current={customPath?.includes(
                                                                    $page.url
                                                                        .pathname,
                                                                ) &&
                                                                    $page.url
                                                                        .pathname ===
                                                                        itemMenu.ref}
                                                            >
                                                                <span
                                                                    class="header-menu-primary__item-link-label"
                                                                    >{itemMenu.label}</span
                                                                >
                                                            </a>
                                                        {/each}
                                                    </div>
                                                {/if}
                                            {:else}
                                                <a
                                                    data-sveltekit-reload
                                                    data-sveltekit-preload-code="eager"
                                                    href={`/${
                                                        permission?.module ===
                                                            "members" &&
                                                        !authToken
                                                            ? "login"
                                                            : permission.module ===
                                                                "stores"
                                                              ? `${permission.module}/product`
                                                              : permission.module ===
                                                                  "about uses"
                                                                ? `about-us`
                                                                : permission.module
                                                    }`}
                                                    role="menuitem"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    style={`color: ${primaryColor} !important;`}
                                                    class="header-menu-primary__item-link header-menu-primary__item-link--level-1 hover:!text-slate-800 hover:!text-opacity-80 hover:no-underline"
                                                    class:header-menu-primary__item-link--current={!customPath?.includes(
                                                        $page.url.pathname,
                                                    ) &&
                                                        $page.url.pathname.includes(
                                                            `${permission.module === "about uses" ? `about-us` : permission.module}`,
                                                        )}
                                                >
                                                    <span
                                                        class="header-menu-primary__item-link-label"
                                                        >{permission.label}</span
                                                    >
                                                </a>
                                            {/if}
                                        </li>
                                    {/if}
                                {/each}
                            {:else}
                                <p>No permissions available</p>
                            {/if}
                        </ul>
                    </nav>
                    <!-- PRIMARY HEADER MENU : end -->
                    <!-- HEADER CTA : begin -->
                    {#if authToken}
                        <div class="header-cta">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <!-- <a class="header-cta__link lsvr-button !bg-rose-500 hover:!bg-rose-600 hover:!text-white cursor-pointer" on:click={handleLogout}>Keluar</a> -->
                            <div class="relative">
                                <div
                                    class={`group flex items-center gap-2 cursor-pointer rounded-[6px]`}
                                    on:click={(event) => {
                                        event?.stopPropagation();
                                        if (popupProfile) {
                                            popupProfile = false;
                                        } else {
                                            popupProfile = true;
                                        }
                                    }}
                                >
                                    <!-- svelte-ignore a11y-img-redundant-alt -->
                                    <img
                                        loading="lazy"
                                        src={getAvatar()}
                                        alt="Photo User"
                                        class={`${popupProfile && "opacity-60"} aspect-square object-cover w-[30px] h-[30px] rounded-full group-hover:opacity-60 transition-opacity duration-150`}
                                    />
                                    <!-- <img src={
                        !profile?.data?.avatar && !localStorage.getItem('avatar_fb') && !avatar_google || avatar_apple ? avatar_null : 
                        (profile?.data?.avatar?.small ? profile?.data?.avatar?.small : localStorage.getItem('avatar_fb') ? localStorage.getItem('avatar_fb') : localStorage.getItem('avatar_google') ? localStorage.getItem('avatar_google') : localStorage.getItem('avatar_apple') )
                      } width="30" height="30" alt="Photo Member" class={`${popupProfile ? 'ring-0 ring-offset-0 ring-transparent' : `ring-1 ${
                        dataPermission?.data?.colors?.primary ? `ring-[${primaryColor}]` : 'outline-rose-500'
                      }`} rounded-full group-hover:ring-0 group-hover:ring-offset-0 ring-offset-[3px] transition-all duration-150`} /> -->
                                    <span
                                        class="name-user-dekstop text-[16px] font-semibold text-slate-800"
                                    >
                                        {`${profile?.data?.name?.split(" ")?.[0] === undefined ? "" : profile?.data?.name?.split(" ")?.[0]} ${profile?.data?.name?.split(" ")?.[1] === undefined ? "" : profile?.data?.name?.split(" ")?.[1]?.length > 15 ? `${profile?.data?.name?.split(" ")?.[1]?.substring(0, 15)}...` : profile?.data?.name?.split(" ")?.[1]?.substring(0, 15)}`}
                                    </span>
                                    <span
                                        class={`name-user-mobile text-[16px] font-semibold text-slate-800`}
                                    >
                                        {`${profile?.data?.name}`}
                                    </span>
                                </div>
                                <div
                                    use:clickOutside={() => {
                                        popupProfile = false;
                                    }}
                                    class={`dialog ${popupProfile ? "open" : "close"} flex flex-col rounded-[6px] border border-gray-300/30 absolute top-[2.75rem] right-0 bg-white shadow-sm`}
                                >
                                    <div
                                        class="w-full item-popup-profile text-slate-800 hover:bg-gray-300/30 p-2 rounded-[4px] transition-all cursor-pointer"
                                        on:click={() => goto("/profile")}
                                    >
                                        Profile
                                    </div>
                                    <div
                                        class="w-full item-popup-profile text-slate-800 hover:bg-gray-300/30 p-2 rounded-[4px] transition-all cursor-pointer"
                                        on:click={handleLogout}
                                    >
                                        Keluar
                                    </div>
                                </div>
                            </div>
                        </div>
                    {:else}
                        {#if clients?.is_use_login === 1 && clientProfile?.code !== "catchmeup"}
                            <div class="header-cta button-login">
                                <span class="button_circle"></span>
                                <a
                                    href="/login"
                                    style="background-color: {primaryColor};"
                                    data-sveltekit-reload
                                    class={`header-cta__link lsvr-button-custom text-white`}
                                >
                                    Masuk
                                </a>
                            </div>
                        {/if}
                        {#if clients?.is_use_register === 1}
                            {#if clients?.code === "catchmeup"}
                                <div class="header-cta button-login">
                                    <span class="button_circle"></span>
                                    <a
                                        href="/subscribe"
                                        style="background-color: {primaryColor};"
                                        data-sveltekit-reload
                                        class={`header-cta__link lsvr-button-custom text-white !px-10`}
                                    >
                                        Berlangganan
                                    </a>
                                </div>
                            {:else if clients?.code !== "catchmeup"}
                                <div class="header-cta button-login">
                                    <span class="button_circle"></span>
                                    <a
                                        href="/register"
                                        style="background-color: {primaryColor};"
                                        data-sveltekit-reload
                                        class={`header-cta__link lsvr-button-custom text-white`}
                                    >
                                        Register
                                    </a>
                                </div>
                            {:else}
                                <div class="header-cta button-login">
                                    <span class="button_circle"></span>
                                    <!-- svelte-ignore a11y-invalid-attribute -->
                                    <a
                                        href="#"
                                        style="background-color: {primaryColor};"
                                        data-sveltekit-reload
                                        class={`header-cta__link lsvr-button-custom text-white`}
                                    >
                                        Loading ..
                                    </a>
                                </div>
                            {/if}
                        {/if}
                    {/if}
                    <!-- HEADER CTA : end -->
                </div>
                <!-- HEADER NAVBAR MENU : end -->
            </div>
        </div>
        <!-- HEADER NAVBAR : end -->
    </div>
</header>

<style>
    /* .changeBackground {
		background-color: white;
		border-bottom: 1px solid #e9e9ea !important;
	}	 */

    .header-mobile-menu-toggle {
        display: none;
    }
    .dialog.open {
        width: 8rem;
        height: auto;
        padding: 8px;
        overflow: auto;
        animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    .dialog.close {
        width: 8rem;
        height: auto;
        padding: 8px;
        overflow: hidden;
        visibility: hidden;
        animation: zoomOut 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
    @keyframes zoom {
        from {
            transform: scale(0.3);
        }
        to {
            transform: scale(1);
        }
    }
    @keyframes zoomOut {
        from {
            transform: scale(1);
        }
        to {
            transform: scale(0);
        }
    }
    .backdrop.open-backdrop {
        animation: fade 0.3s ease-out;
    }
    @keyframes fade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    .button_circle {
        background-color: red;
        border-radius: 1000px;
        position: absolute;
        left: 0;
        top: 0;
        width: 0px;
        height: 0px;
        margin-left: 0px;
        margin-top: 0px;
        pointer-events: none;
        /*animation-timing-function: ease-in-out; */
    }

    .open {
        display: flex !important;
    }

    .closed {
        display: none;
    }

    .lsvr-button-custom {
        border: 0;
        font-weight: 600;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 0.875em;
        white-space: nowrap;
        display: inline-block;
        text-decoration: none;
    }

    .lsvr-button-custom:hover {
        opacity: 0.8;
    }

    @media (max-width: 991px) {
        #header-menu-primary {
            width: 100% !important;
        }
        #header__navbar-menu {
            width: 100%;
            position: absolute;
            padding-bottom: 20px;
            flex-direction: column;
            align-items: flex-start;
            background-color: white;
            border-bottom: 1px solid #e9e9ea;
        }
        .header-mobile-menu-toggle {
            display: block;
        }
        .name-user-dekstop {
            display: none;
        }
        .name-user-mobile {
            display: inline;
        }
    }
    @media (min-width: 992px) {
        #header__navbar-menu {
            display: flex;
        }
        .name-user-dekstop {
            display: inline;
        }
        .name-user-mobile {
            display: none;
        }
    }
</style>
